var map = {
	"./#03CEA4/myInitialEle.svg": "dc69",
	"./#3777FF/myInitialEle.svg": "117b",
	"./#EE964B/myInitialEle.svg": "bc25",
	"./#F754A2/myInitialEle.svg": "d005",
	"./#FF495C/myInitialEle.svg": "a1cc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a197";